export const conflictingSources: string[] = [
  'One video explains blood pressure measurement.',
  'A textbook chapter covers sterile technique.',
  'A slide deck from years ago explains dosage calculation.',
  'Your old notes cover head-to-toe assessment.',
]

export const symptoms: string[] = [
  'And when you need material for fundamentals, assessment, procedures, pharmacology, med-surg, emergency care or simulation...',
  'You’re searching all over again.',
]

export const needsIntro = 'Then your next class or clinical rotation arrives.'

export const needsList: string[] = [
  'You need a clear visual of the body system, the equipment or the technique.',
  'You need the procedure broken down step by step.',
  'You need skills-lab and simulation drills that actually engage your students.',
  'You need ❌/✅ comparisons that correct common clinical errors.',
  'And you need a clear way to see who is really ready for the next clinical step.',
]

export const searchQuestions: string[] = [
  'What should I teach in today’s session?',
  'How do I explain vital signs so students measure them correctly every time?',
  'How do I teach head-to-toe assessment step by step?',
  'How do I correct a sterile technique that keeps breaking?',
  'How do I make dosage calculation click for every student?',
  'How do I give feedback without discouraging anyone?',
  'Where do I find clear visual material for med-surg, emergency care and simulation?',
  'How can I plan better sessions without spending hours every week?',
]

export const painPoints: string[] = [
  'Rebuilding classes and skills labs from scratch every week.',
  'Hours searching scattered textbooks, slides, videos and notes.',
  'Explaining procedures, assessments and calculations with words alone.',
  'Students memorizing steps without understanding why.',
  'No visual material for skills labs, simulation and clinical rotations.',
  'Repeating the same corrections every session.',
  'Assessing competencies without clear criteria.',
  'Losing time you could spend actually teaching.',
  'And constantly wondering if your next session will be good enough.',
]

export const systemShows: string[] = [
  'WHAT TO TEACH.',
  'WHAT TO SHOW.',
  'HOW TO EXPLAIN IT.',
  'HOW TO CORRECT ERRORS.',
  'HOW TO STRUCTURE THE SESSION.',
  'HOW TO ASSESS COMPETENCY.',
]
